import { extend } from 'vee-validate';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

export const name = () =>
  extend('name', {
    validate(value) {
      return {
        valid: /^[A-Za-z0-9\'\-\.\,\s]+$/.test(value),
      };
    },
    message: `Field is limited to these characters: A-Z, a-z, 0-9 and certain symbols ('-.,) in between letters.`,
  });

export const text = () =>
  extend('text', {
    validate(value) {
      return {
        valid: /^[0-9a-zA-Z\'\.\@\-\_]+$/.test(value),
      };
    },
    message: `Field is limited to these characters: A-Z, a-z, 0-9, and certain symbols (.@-_').`,
  });

export const email = () =>
  extend('email', {
    validate(value) {
      return {
        valid: /\S+@\S+\.\S+/.test(value),
      };
    },
    message: 'Please enter a valid email.',
  });

export const phone = () =>
  extend('phone', {
    validate(value) {
      return {
        valid: /^[0-9+-]+$/.test(value),
      };
    },
    message: 'Field is limited to numbers and/or hyphens with + to put your international code.',
  });

export const required = () =>
  extend('required', {
    validate(value) {
      return {
        required: true,
        valid: ['', null, undefined].indexOf(value) === -1,
      };
    },
    computesRequired: true,
    message: 'This field is required.',
  });

export const minLength = () =>
  extend('minLength', {
    validate(value, { len }) {
      return {
        valid: value.length >= len,
      };
    },
    params: ['len'],
    message: `Minimum length is {len} characters.`,
  });

export const password = () =>
  extend('password', {
    params: ['target'],
    validate(value, { target }) {
      return value === target;
    },
    message: 'Passwords do not match.',
  });

export const isDateAfter = () =>
  extend('isDateAfter', {
    validate(curr, { prev }) {
      const currDate = dayjs(curr, 'MM/DD/YYYY').format('YYYY-MM-DD');
      const prevDate = dayjs(prev, 'MM/DD/YYYY').format('YYYY-MM-DD');
      return {
        valid: currDate >= prevDate ? true : false,
      };
    },
    params: ['prev'],
    message: 'Start Date is empty or End Date should be after Start Date.',
  });

export const isDateBefore = () =>
  extend('isDateBefore', {
    validate(curr, { prev }) {
      const currDate = dayjs(curr, 'MM/DD/YYYY').format('YYYY-MM-DD');
      const prevDate = dayjs(prev, 'MM/DD/YYYY').format('YYYY-MM-DD');
      return {
        valid: currDate <= prevDate ? true : false,
      };
    },
    params: ['prev'],
    message: 'End Date is empty or Start Date should be before End Date.',
  });

export const minValue = () =>
  extend('minValue', {
    validate(value, { currVal }) {
      return {
        valid: value >= currVal,
      };
    },
    params: ['currVal'],
    message: 'Value must be greater than or equal to {currVal}.',
  });

export const dateExpiration = () =>
  extend('dateExpiration', {
    validate(date, { numofMonth }) {
      const endDate = dayjs(date, 'MM/DD/YYYY').format('YYYY-MM-DD');
      const futureMonth = dayjs().add(numofMonth, 'M').format('YYYY-MM-DD');
      return {
        valid: futureMonth >= endDate ? true : false,
      };
    },
    params: ['numofMonth'],
    message: 'End Date needs to be less than or equal to {numofMonth} months of current date.',
  });
